// Redux Reducers
import {
  SET_STATE_LOCK_PM,
  SET_ENABLE_PM,
  SET_SOCKET_PM,
  SET_SOCKET_CONNECT_PM,
  SET_STATE_SERVER_PM,
  SET_ROOMS_PM,
  SET_PLAYERS_IN_ROOM_PM,
  SET_WATCHER_PM,
  SET_OUTSIDER_PM,
  SET_TRACKER_PM,
  SET_IN_ROOM_PM,
  SET_NAME_IN_ROOM_PM,
  SET_VISIBLE_CHAT_PM,
  TOGGLE_VISIBLE_CHAT_PM,
  SET_MESSAGES_PM,
  ADD_MESSAGE_PM,
  SET_REQUEST_PM,
  EMIT_SHARED_PLAYLIST_PM,
  EMIT_SUGGESTED_PLAYLIST_PM,
  SET_PERMISSION_STATE_PLAYER_PM,
  BROADCAST_PLAYER_MESSAGE_PM,
  BROADCAST_AUDIO_PM,
  SET_AUDIO_INFOS_PM,
  SET_DEV_PM,
  BROADCAST_CURSOR_FROM_ACTION_PM,
  SET_QUEUES_DJ_PM,
  SET_RESPONSE_TO_DJ_PM,
  SET_SHOW_AUDIO,
  REFRESH_PUBLIC_SESSIONS
} from "../types";

const initialState = {
  lockPM: true,
  enablePM: false,
  socketPM: null,
  socketConnectPM: false,
  serverPM: false,
  inRoomPM: null,
  playersInRoomPM: [],
  isWatcherPM: true,
  isOutsider: false,
  isTracker: true,
  roomsPM: [],
  messagesPM: [],
  showChatPM: true,
  requestPM: null,
  permissionStatePlayerPM: false,
  playerMessagePM: null,
  broadcastAudio: null,
  audioInfosPM: null,
  devPM: false,
  cursorFromActionPM: null,
  queuesDJ: [],
  responseToDJ: null,
  showAudio: false,
  refreshPublicSessions: null
};

function partymodeReducer(state = initialState, action) {

  if (action.type === SET_STATE_LOCK_PM) {
    return { ...state, lockPM: action.payload }
  }

  if (action.type === SET_ENABLE_PM) {
    return { ...state, enablePM: action.payload }
  }

  if (action.type === SET_SOCKET_PM) {
    return { ...state, socketPM: action.payload }
  }

  if (action.type === SET_SOCKET_CONNECT_PM) {
    return { ...state, socketConnectPM: action.payload }
  }

  if (action.type === SET_STATE_SERVER_PM) {
    return { ...state, serverPM: action.payload }
  }

  if (action.type === SET_ROOMS_PM) {
    return { ...state, roomsPM: action.payload }
  }

  if (action.type === SET_PLAYERS_IN_ROOM_PM) {
    return { ...state, playersInRoomPM: action.payload }
  }

  if (action.type === SET_WATCHER_PM) {
    return { ...state, isWatcherPM: action.payload }
  }

  if (action.type === SET_OUTSIDER_PM) {
    return { ...state, isOutsider: action.payload }
  }

  if (action.type === SET_TRACKER_PM) {
    return { ...state, isTracker: action.payload }
  }

  if (action.type === SET_IN_ROOM_PM) {
    return { ...state, inRoomPM: action.payload }
  }

  if (action.type === SET_NAME_IN_ROOM_PM) {
    const newState = state.inRoomPM;
    if (newState && newState.name) { newState.name = action.payload }
    return { ...state, inRoomPM: newState }
  }

  if (action.type === SET_VISIBLE_CHAT_PM) {
    return { ...state, showChatPM: action.payload }
  }

  if (action.type === TOGGLE_VISIBLE_CHAT_PM) {
    return { ...state, showChatPM: !state.showChatPM }
  }

  if (action.type === SET_MESSAGES_PM) {
    return { ...state, messagesPM: action.payload }
  }

  if (action.type === ADD_MESSAGE_PM) { // Limited to 50 to reduce re-rendering
    return { ...state, messagesPM: [...state.messagesPM.slice(-50), action.payload] }
  }

  if (action.type === SET_REQUEST_PM) {
    return { ...state, requestPM: action.payload }
  }

  if (action.type === EMIT_SHARED_PLAYLIST_PM) {
    (state.socketPM) && state.socketPM.emit(`update shared playlist`, action.payload)
    return { ...state }
  }

  if (action.type === EMIT_SUGGESTED_PLAYLIST_PM) {
    (state.socketPM) && state.socketPM.emit(`update suggested playlist`, action.payload)
    return { ...state }
  }

  if (action.type === SET_PERMISSION_STATE_PLAYER_PM) {
    return { ...state, permissionStatePlayerPM: action.payload }
  }

  if (action.type === BROADCAST_PLAYER_MESSAGE_PM) {
    return { ...state, playerMessagePM: action.payload }
  }

  if (action.type === BROADCAST_AUDIO_PM) {
    return { ...state, broadcastAudio: action.payload }
  }

  if (action.type === SET_AUDIO_INFOS_PM) {
    return { ...state, audioInfosPM: action.payload }
  }

  if (action.type === SET_DEV_PM) {
    return { ...state, devPM: action.payload }
  }

  if (action.type === BROADCAST_CURSOR_FROM_ACTION_PM) {
    return { ...state, cursorFromActionPM: action.payload }
  }

  if (action.type === SET_QUEUES_DJ_PM) {
    return { ...state, queuesDJ: action.payload }
  }

  if (action.type === SET_RESPONSE_TO_DJ_PM) {
    return { ...state, responseToDJ: action.payload }
  }

  if (action.type === SET_SHOW_AUDIO) {
    return { ...state, showAudio: action.payload }
  }

  if (action.type === REFRESH_PUBLIC_SESSIONS) {
    return { ...state, refreshPublicSessions: action.payload }
  }

  return state;
};

export default partymodeReducer;
